import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { factory } from "./auth-service-tools248.js";
import { useDirection } from "./auth-service-tools250.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { useRadioGroupContext } from "./auth-service-tools394.js";
import { RadioCardProvider } from "./auth-service-tools399.js";
import classes from "./auth-service-tools400.js";
const defaultProps = {
  withBorder: true
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    radius
  } = _ref;
  return {
    card: {
      "--card-radius": getRadius(radius)
    }
  };
});
const RadioCard = factory((_props, ref) => {
  const props = useProps("RadioCard", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    checked,
    mod,
    withBorder,
    value,
    onClick,
    name,
    onKeyDown,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "RadioCard",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "card"
  });
  const {
    dir
  } = useDirection();
  const ctx = useRadioGroupContext();

  const _checked = typeof checked === "boolean" ? checked : (ctx == null ? void 0 : ctx.value) === value || false;

  const _name = name || (ctx == null ? void 0 : ctx.name);

  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);

    if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(event.nativeEvent.code)) {
      event.preventDefault();
      const siblings = Array.from(document.querySelectorAll(`[role="radio"][name="${_name || "__mantine"}"]`));
      const currentIndex = siblings.findIndex(element => element === event.target);
      const nextIndex = currentIndex + 1 >= siblings.length ? 0 : currentIndex + 1;
      const prevIndex = currentIndex - 1 < 0 ? siblings.length - 1 : currentIndex - 1;

      if (event.nativeEvent.code === "ArrowDown") {
        siblings[nextIndex].focus();
        siblings[nextIndex].click();
      }

      if (event.nativeEvent.code === "ArrowUp") {
        siblings[prevIndex].focus();
        siblings[prevIndex].click();
      }

      if (event.nativeEvent.code === "ArrowLeft") {
        siblings[dir === "ltr" ? prevIndex : nextIndex].focus();
        siblings[dir === "ltr" ? prevIndex : nextIndex].click();
      }

      if (event.nativeEvent.code === "ArrowRight") {
        siblings[dir === "ltr" ? nextIndex : prevIndex].focus();
        siblings[dir === "ltr" ? nextIndex : prevIndex].click();
      }
    }
  };

  return /* @__PURE__ */jsxRuntimeExports.jsx(RadioCardProvider, {
    value: {
      checked: _checked
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, {
      ref,
      mod: [{
        "with-border": withBorder,
        checked: _checked
      }, mod],
      ...getStyles("card"),
      ...others,
      role: "radio",
      "aria-checked": _checked,
      name: _name,
      onClick: event => {
        onClick == null ? void 0 : onClick(event);
        ctx == null ? void 0 : ctx.onChange(value || "");
      },
      onKeyDown: handleKeyDown
    })
  });
});
RadioCard.displayName = "@mantine/core/RadioCard";
RadioCard.classes = classes;
export { RadioCard };